import React, { Component } from 'react';
import { TweenMax } from 'gsap';
import RegisterBlock from "../modules/RegisterBlock";
import OutageGuarantee from "../modules/OutageGuarantee";
import globals from '../globals';
import Hero from "../modules/Hero/Hero";
import HelmetDefault from "../layout/HelmetDefault";
import NbnEnterpriseForm from "../forms/NbnEnterpriseForm/NbnEnterpriseForm";
import Button from "../elements/Button";
import SecondHeading from "../modules/SecondHeading";
import OwlCarousel from "react-owl-carousel2";
import Heading from "../elements/Heading";
import NbnEnterprisePlan from "../components/NbnEnterprisePlan";

class InternetEnterpriseNbn extends Component {

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			subTitle: '',
			leadCopy: [],
			secondHeading: {},
            upgradeBanner: {features: [], list: []},
            caseStudies: [],
            whyChooseUs: {list: []},
			internetPlans: {},
			serviceAgreement: {},
            plans: {plans: []},
			form: {},
			readyForFuture: {listLeft: [], listRight: []},
			seoTitle: '',
			seoDescription: '',
			dataReceived: false
		};
	}

	componentDidMount() {
		this.getData();
	}

	getData() {
		fetch('/api/internet/enterprise-nbn')
			.then(result => result.json())
			.then((result) => {
				this.setState(result);
				this.setDataReceived();
				globals.animatePageIn(this.container);
			});
	}

	setDataReceived() {
		this.setState({
			dataReceived: true
		});
	}

	scrollToForm(event) {
		event.preventDefault();
		let form = document.getElementById('business-fibre-form');
		TweenMax.to(window, 0.5, {scrollTo: (form.offsetTop - 60)});
    }
    
    handleClickCta(event) {
        this.scrollToForm(event)
        globals.pushGA4Events('bannerCtaClick', {
            eventInfo: {
                clickText: "View Prices",
                clickUrl: window.location.href,
                pageCategory: 'Business'
            }
        })
    }

	render() {
		return (
			<div ref={(el) => this.container = el} style={{opacity: 0}}>
				<HelmetDefault {...this.state} />
				<Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived}>
                    <div className="upgrade-banner">
                        <p className="title bold m-0 mb-4">{this.state.upgradeBanner.title}</p>
                        <p className="m-0 mb-2 upgrade-bold">{this.state.upgradeBanner.speed} <span>|</span> {this.state.upgradeBanner.price}</p>
                        <ul>
                            {this.state.upgradeBanner.features.map((item, key) => {
                                return <li key={key}>{item}</li>;
                            })}
                        </ul>
                        <p className="font-tiny m-0 upgrade-terms" dangerouslySetInnerHTML={{__html: this.state.upgradeBanner.terms}} />
                        <div className="powered-by-nbn">
                            <img src="/images/powered-by-nbn.png" alt="Powered by Business nbn" />
                        </div>
                    </div>
                    <div className="my-5">
                        <Button
                            action={event => this.handleClickCta(event)}
                            newClass="scroll-to-pricing"
                            image="/images/btn-view-prices.svg"
                            alt="View Prices"
                        />
                    </div>
                    <div className="green-list">
                        {this.state.upgradeBanner.list.map((item, key) => {
                            return (
                                <div key={key}>
                                    <span className="color-lime">•</span> {item}
                                </div>
                            );
                        })}
                    </div>
				</Hero>
                <NbnEnterpriseForm
                    speeds={[250, 500, 1000]}
                    submitFormUrl="/api/submit-enterprise-nbn-form"
                    getPricingUrl="/api/get-enterprise-nbn-pricing"
                    title={this.state.form.title}
                    subTitle={this.state.form.subTitle}
                    leadCopy={this.state.form.leadCopy}
                    eventNameSpeed="businessNbnEthernetFormSpeed"
                    eventNameSubmit="businessNbnEthernetFormSubmit"
                >
                    <div className="mb-5">
                        <Heading title={this.state.plans.title} />
                        <div className="d-none d-lg-flex plans">
                            {this.state.plans.plans.map((plan, key) => {
                                return <NbnEnterprisePlan key={key} item={plan} />;
                            })}
                        </div>
                        <div className="d-lg-none plans-mobile">
                            {this.state.plans.plans.length > 0 &&
                                <OwlCarousel options={{
                                    items: 1,
                                    loop: false,
                                    autoHeight: false,
                                    autoplay: false,
                                    dots: true
                                }}>
                                    {this.state.plans.plans.map((plan, key) => {
                                        return <NbnEnterprisePlan key={key} item={plan} />;
                                    })}
                                </OwlCarousel>
                            }
                        </div>
                        <div className="text-center cis">
                            <a href="https://files.exetel.com.au/cis/nbnee/2025-09/Exetel_CIS_nbnEE_Low.pdf" className="font-small mx-3" target="_blank">
                                Critical information summary Low CoS
                            </a>|<a href="https://files.exetel.com.au/terms/Exetel_Business_nbn_EE_Low_CoS_KFS.pdf" className="font-small mx-3" target="_blank">
                                Key fact sheet Low CoS
                            </a><br/>
                            <a href="https://files.exetel.com.au/cis/nbnee/2025-09/Exetel_CIS_nbnEE_High.pdf" className="font-small mx-3" target="_blank">
                                Critical information summary High CoS
                            </a>|<a href="https://files.exetel.com.au/terms/Exetel_Business_nbn_EE_High_CoS_KFS.pdf" className="font-small mx-3" target="_blank">
                                Key fact sheet High CoS
                            </a>
                        </div>
                    </div>

                </NbnEnterpriseForm>
                <div className="ready-for-future">
                    <div className="half text">
                        <Heading title={this.state.readyForFuture.title} subTitle={this.state.readyForFuture.subTitle}>
                            <p>{this.state.readyForFuture.leadCopy}</p>
                        </Heading>
                        <div className="mt-lg-5">
                            {this.state.readyForFuture.listLeft.map((item, key) => {
                                return (
                                    <div key={key} className="list-item">
                                        <p className="title m-0 mb-2" dangerouslySetInnerHTML={{__html: item.title}} />
                                        <p className="m-0">{item.content}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="half">
                        <div className="image">
                            <img src="/images/bg-nbn-enterprise-ethernet-2.png" alt="Exetel nbn Enterprise Ethernet" />
                        </div>
                        <div className="mt-lg-5 text">
                            {this.state.readyForFuture.listRight.map((item, key) => {
                                return (
                                    <div key={key} className="list-item">
                                        <p className="title m-0 mb-2" dangerouslySetInnerHTML={{__html: item.title}} />
                                        <p className="m-0">{item.content}</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
				<div className="second-heading-wrapper">
					<div className="inner">
						<SecondHeading data={this.state.secondHeading}>
                            <div className="case-studies mt-3">
                                {this.state.caseStudies.length > 0 ?
                                    <OwlCarousel options={{
                                        items: 1,
                                        loop: true,
                                        autoHeight: false,
                                        autoplay: true
                                    }}>
                                        {this.state.caseStudies.map((item, key) => {
                                            return (
                                                <div key={key} className="case-study">
                                                    <div className="logo">
                                                        <img src={`/images/logos/${item.logo}`} alt={item.logo} />
                                                    </div>
                                                    <div className="quote">
                                                        <p>"{item.quote}"</p>
                                                    </div>
                                                    <p className="author" dangerouslySetInnerHTML={{__html: item.author}} />
                                                </div>
                                            );
                                        })}
                                    </OwlCarousel>
                                : ''}
                            </div>
                        </SecondHeading>
					</div>
					<div className="bottom-wave-darkgreen" />
				</div>
                <div className="why-choose-us">
                    <Heading title={this.state.whyChooseUs.title} subTitle={this.state.whyChooseUs.subTitle} />
                    <div className="choose-container">
                        {this.state.whyChooseUs.list.map((item, key) => {
                            return (
                                <div key={key} className="choose">
                                    <img src={`/images/${item.icon}`} alt={item.title} />
                                    <div className="choose-copy">
                                        <h5 className="m-0 mb-3">{item.title}</h5>
                                        <p className="m-0">{item.content}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
				<OutageGuarantee />
				<RegisterBlock />
			</div>
		);
	}

}

export default InternetEnterpriseNbn;


// WEBPACK FOOTER //
// ./resources/assets/js/internet/InternetEnterpriseNbn.js